import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Title from 'common/title/Title';
import Unauthorized from './unauthorized';

const MainRoutes = () =>
  <Title>
    <Routes>
      <Route path='/' component={Unauthorized} />
      <Route
        path='*'
        element={<Navigate to='/' replace />}
      />
    </Routes>
  </Title>;
export default MainRoutes;
